import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useSelector } from "react-redux";
import { useState } from "react";
import styles from "./KeenSlider.module.css";
import { Link } from "react-router-dom";
import AddToCart from "../../QtyCounter/AddToCart";

function Arrow(props) {
  return (
    <svg
      onClick={props.onClick}
      className={`${styles.arrow} + ${
        props.left ? `${styles.arrowleft}` : `${styles.arrowright}`
      } `}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      {props.left && (
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
      )}
      {!props.left && (
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      )}
    </svg>
  );
}

function KeenSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const products = useSelector((state) => state.products);
  const [sliderRef, instanceRef] = useKeenSlider({
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
    loop: true,
    mode: "free",
    slides: {
      perView: "2",
      spacing: 25,
    },
    breakpoints: {
      "(min-width: 600px)": {
        slides: {
          perView: "4",
          spacing: 25,
        },
      },
      "(max-width: 800)": {
        slides: {
          perView: "4",
          spacing: 25,
        },
      },
      "(min-width: 800px)": {
        slides: {
          perView: "3",
          spacing: 25,
        },
      },
    },
  });

  return (
    <div ref={sliderRef} className="keen-slider">
      {products.map((product) => (
        <div key={product.id}>
          {!product.deletedAt && product.featured ? (
            <div className="col-6 keen-slider__slide">
              <div className={styles.card}>
                <div className={styles.iconContainer}>
                  {product.glutenfree ? (
                    <img
                      className={styles.glutenFree}
                      src="../img/gluten-free.svg"
                      alt="gluten-free"
                    />
                  ) : (
                    <></>
                  )}
                  {product.sugarfree ? (
                    <img
                      className={styles.sugarFree}
                      src="../img/sugar-free.svg"
                      alt="sugar-free"
                    />
                  ) : (
                    <></>
                  )}
                </div>
                {product.stock === 0 ? (
                  <img
                    className={styles.stockBadge}
                    src="../img/no-stock.png"
                    alt="no-stock"
                  />
                ) : (
                  <></>
                )}
                <img
                  src={product.pictures[0].img1}
                  alt={product.name}
                  className={styles.background + " rounded"}
                />
                <div className={styles.cardDetail}>
                  <h5 className="text-center">{product.name}</h5>
                  <p className="text-center fs-6 px-4">{product.description}</p>

                  {product.stock > 0 ? (
                    <>
                      <Link
                        to={`/${product.slug}`}
                        className={styles.btnInfo + " btn mb-5 text-white"}
                      >
                        Ver detalle
                      </Link>
                      <AddToCart product={product} />{" "}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <span
                className={
                  styles.spanDetail + " d-flex justify-content-between px-1"
                }
              >
                <small className="">{product.name}</small>
                <small className="text-end fw-bold">$ {product.price}</small>
              </span>
            </div>
          ) : (
            <></>
          )}
        </div>
      ))}
      {loaded && instanceRef.current && (
        <>
          <Arrow
            left
            onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
          />

          <Arrow
            onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
          />
        </>
      )}
    </div>
  );
}

export default KeenSlider;
